import React from "react";
import { Primary } from "../Buttons/Button.stories";
import Vector from "../../assets/icons/Vector.svg";
import InformationFill from "../../assets/icons/Information-fill.svg";
import WarningFill from "../../assets/icons/Warning-fill.svg";

/**
 * Reusable confirmation popup used across flows like
 * "Forgot Password", "Consultation Cancelled", etc.
 *
 * @param {string} title - Heading text
 * @param {React.ReactNode} message - Body/subheading text
 * @param {React.ReactNode} infoText - Optional text shown inside the info callout box
 * @param {string} infoIcon - Optional icon for the info callout box
 * @param {string} icon - Icon shown in the circular badge (defaults to check/Vector icon)
 * @param {boolean} showIcon - Whether to show the circular icon badge
 * @param {string} primaryLabel - Primary button label
 * @param {string} primaryIcon - Optional icon replacing the default arrow on the primary button
 * @param {string} primaryHref - Primary button href (if link-based navigation)
 * @param {function} onPrimaryClick - Primary button click handler (if action-based)
 * @param {string} secondaryLabel - Optional secondary link label (e.g. "Resend email")
 * @param {function} onSecondaryClick - Optional secondary link click handler
 * @param {string} className - Extra className to extend/override styling per usage
 * @param {React.ReactNode} children - Optional extra content rendered below the info box
 */
function VHConfirmationPopup({
  title = "",
  message = "",
  infoText = "",
  warningText = "",
  warningIcon = WarningFill,
  infoIcon = InformationFill,
  icon = Vector,
  showIcon = true,
  primaryLabel = "",
  primaryIcon = "",
  primaryHref = "",
  onPrimaryClick = null,
  secondaryLabel = "",
  onSecondaryClick = null,
  className = "",
  children,
}) {
  return (
    <div className={`vh-confirmation-popup ${className}`}>
      {showIcon && (
        <div className="vh-confirmation-popup__icon">
          <div className="vh-confirmation-popup__icon-circle">
            <img src={icon} alt="" />
          </div>
        </div>
      )}

      {title && <h2 className="vh-confirmation-popup__title">{title}</h2>}

      {message && <p className="vh-confirmation-popup__message">{message}</p>}

      {infoText && (
        <div className="vh-confirmation-popup__info-box">
          <img src={infoIcon} alt="" />
          <span>{infoText}</span>
        </div>
      )}

      {warningText && (
        <div className={`vh-confirmation-popup__warning-box ${className}`}>
          <img src={warningIcon} alt="" />
          <span>{warningText}</span>
        </div>
      )}

      {children}

      {primaryLabel && (
        <div className="vh-confirmation-popup__actions">
          <div
            className="form-group"
            style={primaryIcon ? { "--vh-primary-icon": `url("${primaryIcon}")` } : undefined}
          >
            <Primary
              href={primaryHref || undefined}
              onClick={onPrimaryClick}
              label={primaryLabel}
              className="vh-confirmation-popup__primary-btn"
            />
          </div>
        </div>
      )}

      {secondaryLabel && (
        <a
          href="#"
          className="vh-confirmation-popup__secondary-link"
          onClick={onSecondaryClick}
        >
          {secondaryLabel}
        </a>
      )}
    </div>
  );
}

export default VHConfirmationPopup;